<template>
  <div class="common-back-header __flex __flex-vc __flex-cb">
    <img src="@/assets/images/common/left_icon.png" class="img-logo" alt="" @click="toPrePage()">
    <img v-if="screenIcon" :src="screenType?require('@/assets/images/common/icon_v_h.png'):require('@/assets/images/common/icon_h_v.png')" class="screen-icon" alt="" @click="changeScreenType()">
  </div>
</template>

<script>
export default {
  name: 'CommonHeader',
  props: {
    backPath: {
      type: String,
      default: '/home'
    },
    tabIndex: {
      type: String,
      default: ''
    },
    currentIndex: {
      default: ''
    },
    swiperIndex: {
      default: ''
    },
    screenIcon: { // 是否显示横屏图标
      type: Boolean,
      default: false
    },
    screenType: { // 是否为横屏
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    toPrePage () {
      if (this.tabIndex) {
        this.$router.push({
          path: '/' + this.backPath,
          query: {
            tabIndex: this.tabIndex
          }
        })
      } else {
        if (this.backPath == 'home') {
          this.$router.push({
            path: '/' + this.backPath
          })
        } else {
          this.$router.push({
            path: '/' + this.backPath,
            query: {
              currentIndex: this.currentIndex,
              swiperIndex: this.swiperIndex
            }
          })
        }
      }
    },
    changeScreenType () {
      this.$emit('handle-change-screen', true)
    }
  },
}
</script>

<style scoped lang="scss">
.common-back-header {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  // box-shadow: 0px 3px 18px 0px rgba(51, 51, 51, 0.25);
  img{
    width: 9px;
    height: 16px;
  }
  .screen-icon{
    width: 18px;
    height: 18px;
  }
}
</style>
